// ลำดับ 3 งวดที่ควรมีต่อเดือน — ใช้วาดจุดบอกสถานะครบ/ไม่ครบต่อแถว (PeriodDots)
export const PERIOD_SLOTS = [
  { key: 'first', label: 'งวด 1-15 (รายวัน)' },
  { key: 'second', label: 'งวด 16-สิ้นเดือน (รายวัน)' },
  { key: 'fulltime', label: 'รายเดือน' },
];

// คอลัมน์ตัวเลขที่ใช้ร่วมกันระหว่างตารางสรุป (EmployeeGroupTable) และตาราง sub-row ต่องวด —
// ไม่รวม "สุทธิ" เพราะ render แยกเป็นคอลัมน์ปิดท้ายเสมอ (เน้นตัวหนา ไม่ปนกับ field อื่น)
export const COLUMNS = [
  { key: 'salary', label: 'ค่าแรง' },
  { key: 'overtime', label: 'OT' },
  { key: 'field_allowance', label: 'ค่าออกสนาม' },
  { key: 'bonus', label: 'โบนัส' },
  { key: 'allowances', label: 'เบี้ยเลี้ยง' },
  { key: 'other_income', label: 'อื่นๆ(รายรับ)' },
  { key: 'sso', label: 'ประกันสังคม' },
  { key: 'tax', label: 'ภาษี' },
  { key: 'late', label: 'มาสาย' },
  { key: 'other_deduction', label: 'อื่นๆ(หัก)' },
];

// สีต้องตรงกับที่ backend เขียนลง Excel จริง (ดู backend/helpers/ssoExportExcel.helper.js GROUP_FILL/
// HEADER_FILL — ตัดตัวอักษร alpha "FF" นำหน้าออกให้เหลือ #RRGGBB เฉยๆ สำหรับใช้เป็น CSS color)
export const SSO_GROUP_COLORS = {
  FULLTIME: '#C6E0B4',
  DAILY: '#BDD7EE',
  LEFT: '#FFFF00',
  MONTHLY_ADDITION: '#F8CBAD',
  EXTERNAL: '#D9C2E9',
};
export const SSO_HEADER_COLOR = '#92D050';
export const SSO_MISSING_ID_COLOR = '#D32F2F';

export const SSO_GROUP_LABELS = {
  FULLTIME: 'รายเดือน',
  DAILY: 'รายวัน',
  LEFT: 'ออกไปแล้ว (ยังต้องส่ง ปกส.)',
  MONTHLY_ADDITION: 'เพิ่มเฉพาะเดือนนี้',
  EXTERNAL: 'คนนอก',
};

export const SSO_EXCEL_COLUMNS = [
  { key: 'tax_id', label: 'เลขบัตรประชาชน' },
  { key: 'title', label: 'คำนำหน้า' },
  { key: 'firstname', label: 'ชื่อ' },
  { key: 'lastname', label: 'สกุล' },
  { key: 'salary', label: 'ค่าจ้างเดือน' },
  { key: 'sso', label: 'เงินสมทบ' },
];
